import React from 'react';
import './FriendlyAlertModal.css';

export default function FriendlyAlertModal({
  show,
  title = 'แจ้งเตือน',
  message,
  onClose,
  actions = [],
  icon = '🥺',
}) {
  if (!show) return null;

  return (
    <div className="fam-overlay" role="dialog" aria-modal="true">
      <div className="fam-modal">
        <div className="fam-header">
          <div className="fam-icon" aria-hidden>{icon}</div>
          <h3 className="fam-title">{title}</h3>
        </div>
        <div className="fam-body">
          {typeof message === 'string' ? (
            <p className="fam-message">{message}</p>
          ) : (
            message
          )}
        </div>
        <div className="fam-actions">
          {actions && actions.length > 0 ? (
            actions.map((a, idx) => (
              <button
                key={idx}
                className={`fam-btn ${a.variant === 'secondary' ? 'fam-btn-secondary' : 'fam-btn-primary'}`}
                onClick={a.onClick}
              >
                {a.label}
              </button>
            ))
          ) : (
            <button className="fam-btn fam-btn-primary" onClick={onClose}>
              ปิด
            </button>
          )}
        </div>
      </div>
    </div>
  );
}